<template>
  <div :class="success ?  'GetSkillAction' : 'GetSkillAction__error' ">
    <div class="GetSkillAction__header">
      <span>Retrieve Skill{{ outputObject?.name ? `: ${outputObject?.name }` : ``}}</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend && success">
      <div v-if="isValidJson" class="GetSkillAction__body">
        <div class="preview-content" v-html="renderedMarkdown"></div>
      </div>
      <div v-if="!isValidJson && typeof outputObject !== 'string'" style="padding: 10px">
        <v-progress-circular
          :size="20"
          :width="1"
          color="primary"
          indeterminate
        />
      </div>
      <div v-if="!isValidJson && typeof outputObject === 'string'" class="GetSkillAction__body">
        {{ outputObject }}
      </div>
    </div>

    <div v-if="extend && !success">
      <div class="GetSkillAction__error_body">
        <span style="font-weight: bold;">Error: </span> {{ outputObject }}
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import markdownit from 'markdown-it';

export default {
  name: 'get-skill-output',
  components: {},
  props: {
    output: {},
    name: {},
    success: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    outputObject() {
      return typeof this.output !== 'string' ? this.output : JSON.parse(this.output);
    },
    isValidJson() {
      try {
        if(typeof this.output !== 'string') {
          return true;
        }
        JSON.parse(this.output);
        return true
      } catch (e) {
        return false;
      }
    },
    renderedMarkdown() {
      if (!this.outputObject.content) return '';
      try {
        return this.renderMarkdown(this.outputObject.content);
      } catch (error) {
        return '<p>Invalid markdown syntax</p>';
      }
    },
  },
  methods: {
    renderMarkdown(text) {
      const md = markdownit({
        breaks: true,
        linkify: true,
      });
      return md.render(text);
    },
  },
};
</script>

<style scoped lang="scss">
@import './index';
</style>
